module.exports = __webpack_public_path__ + "img/tesoreria.ef582eab.svg";